<!-- 疑似没有用的组件 -->
<template>
  <div
    ref="googleMap"
    :style="`width:${width}px;height:${height}px;`"
    :class="['google-map', { disabled: !hasPosition }]"
  ></div>
</template>
<script>
export default {
  name: 'GoogleMap',
  props: {
    /* 位置信息 */
    position: {
      type: Object,
    },
    /* 地图宽度 */
    width: {
      type: Number,
      default: 200,
    },
    /* 地图高度 */
    height: {
      type: Number,
      default: 200,
    },
    /* 显示详细位置 */
    detailVisible: {
      type: Number,
      default: 0,
    },
    /* 圆的半径 */
    radius: {
      type: Number,
      default: 150,
    },
    /* 缩放比例 */
    zoom: {
      type: Number,
      default: 15,
    },
    /* 控件尺寸 像素*/
    controlSize: {
      type: Number,
      default: 0,
    },
    /* 地图类型切换按钮显示状态 */
    mapTypeVisible: {
      type: Boolean,
      default: false,
    },
    /* 是否允许点击地图图标 */
    clickableIcons: {
      type: Boolean,
      default: false,
    },
    /* 是否可拖拽 */
    draggable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    /* 是否存在位置信息 */
    hasPosition() {
      const position = this.position;
      return position && position.lat && position.lng;
    },
  },
  data() {
    return {
      /* 地图实例 */
      map: null,
      /* 标记点 */
      marker: null,
      /* 圆 */
      circle: null,
    };
  },
  watch: {
    detailVisible(detailVisible) {
      if (!this.hasPosition) return;
      detailVisible ? this.createMarker() : this.createCircle();
    },
    position: {
      deep: true,
      handler(position) {
        if (!this.hasPosition) return;

        this.map.setCenter(this.position);

        if (this.detailVisible) {
          this.createMarker();
          this.circle && this.circle.setMap(null);
        } else {
          this.createCircle();
          this.marker && this.marker.setMap(null);
        }
      },
    },
  },
  mounted() {
    this.initGoogleMap();
    if (this.hasPosition) {
      this.detailVisible ? this.setMarker() : this.setCircle();
    }
  },
  methods: {
    /* 初始化谷歌地图 */
    async initGoogleMap() {
      await this.loadGoogleApi();

      const center = this.hasPosition ? this.position : { lat: 43.65332780000001, lng: -79.38403079999999 };

      this.map = new google.maps.Map(this.$refs.googleMap, {
          center,
          zoom: this.zoom,
          controlSize: `${this.controlSize}px` /* 控件尺寸 */,
          clickableIcons: this.clickableIcons /* 禁止点击图标显示位置 */,
          disableDoubleClickZoom: true /* 禁止双击缩放地图 */,
          mapTypeControl: this.mapTypeVisible /* 地图类型切换按钮显示状态 */,
          draggable: this.draggable /* 是否可拖拽 */,
      });
      this.map.addListener("click", (mapsMouseEvent) => {
        // Close the current InfoWindow.
        console.log(mapsMouseEvent.latLng.toJSON());
        this.$emit('updatePosition',mapsMouseEvent.latLng.toJSON());
      });
    },
    /* 创建 marker */
    createMarker() {
      this.marker && this.marker.setMap(null);
      this.marker = new google.maps.Marker({
        map: this.map,
        position: this.position,
        draggable: false,
      });
    },
    /* 创建圆 */
    createCircle(position) {
      this.circle && this.circle.setMap(null);
      this.circle = new google.maps.Circle({
        map: this.map,
        center: this.position,
        radius: this.radius /* 半径  */,
        strokeWeight: 0 /* 边框宽度 */,
      });
    },
    /* 加载 google api */
    loadGoogleApi() {
      return new Promise(resolve => {
        const isProduction = process.env.NODE_ENV === 'production';
        const baseURL = 'https://maps.googleapis.com';
        const url = `${baseURL}/maps/api/js?key=AIzaSyCSm2-liGRSNaaxq61Iq1Q7qdF_m0kAK2s&language=zh-CN`;
        const googleMapScript = document.createElement('script');
        googleMapScript.setAttribute('src', url);
        document.head.appendChild(googleMapScript);

        if (googleMapScript.readyState) {
          googleMapScript.onreadystatechange = () => {
            if (googleMapScript.readyState === 'complete' || googleMapScript.readyState === 'loaded') {
              resolve();
            }
          };
        } else {
          googleMapScript.onload = () => {
            resolve();
          };
        }
      });
    },
  },
};
</script>
<style lang="scss">
.google-map {
  position: relative;
}
.google-map.disabled:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background:url('~@/assets/images/info/map.png') no-repeat center center;
  background-size: 100% 100%;
 // filter: blur(10px);
}
</style>
